import React from 'react'
import { observer } from 'mobx-react-lite'
import Button from 'shared/ui/Button/Button'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'

import ContentFiltersPanel from 'widgets/FiltersPanel/components/ContentFiltersPanel/ContentFiltersPanel'
import DropdownFilter from 'widgets/FiltersPanel/components/DropdownFilter/DropdownFilter'
import InactiveColumns from 'widgets/FiltersPanel/components/InactiveColumns/InactiveColumns'
import ColumnsManager from 'widgets/FiltersPanel/components/ColumnsManager/ColumnsManager'

import { useFiltersStudentsContent } from './hooks/useFiltersStudentsContent'
import s from './styles/FiltersStudentsContent.module.scss'

const FiltersStudentsContent = observer(({ onClose }) => {
	const {
		filtersConfig,
		onChangeKey,
		onApply,
		inactiveColumns,
		managerColumns,
		onActivateColumn,
		onDeactivateColumn,
		onReorderActive,
	} = useFiltersStudentsContent({ onClose })

	return (
		<ContentFiltersPanel
			title="Filters"
			subtitle="Select multiple filters"
			icon={<FilterIcon />}
			onClose={onClose}
		>
			<div className={s.section}>
				{filtersConfig.map(f => (
					<DropdownFilter
						key={f.key}
						filterKey={f.key}
						title={f.title}
						options={f.options}
						selected={f.selected}
						onChangeKey={onChangeKey}
					/>
				))}
			</div>

			<Button onClick={onApply}>Search</Button>

			<InactiveColumns items={inactiveColumns} onActivate={onActivateColumn} />

			<ColumnsManager
				items={managerColumns}
				onReorder={onReorderActive}
				onDeactivate={onDeactivateColumn}
			/>
		</ContentFiltersPanel>
	)
})

export default FiltersStudentsContent
